import { useSubscription } from '@apollo/client'
import { useState } from 'react'

import logger from '@/utils/logger'

import { useUser } from '@/client/context/user'
import { useIsPageVisible } from '@/client/hooks'
import { USER_UNDISPLAYED_ACHIEVEMENTS_SUBSCRIPTION } from '@/client/services/hasura'
import type {
  UserUndisplayedAchievementsSubscription,
  UserUndisplayedAchievementsSubscriptionVariables,
} from '@/client/services/hasura/generated/graphql'
import type { AchievementId } from '@/client/services/progression'

export default function useUndisplayedUserAchievements(): {
  achievementIds: AchievementId[]
  loading: boolean
} {
  const user = useUser()
  const isPageVisible = useIsPageVisible()

  const [achievementIds, setAchievementIds] = useState<AchievementId[]>([])

  const { loading } = useSubscription<
    UserUndisplayedAchievementsSubscription,
    UserUndisplayedAchievementsSubscriptionVariables
  >(USER_UNDISPLAYED_ACHIEVEMENTS_SUBSCRIPTION, {
    variables: {
      userId: user.id,
    },
    skip: !isPageVisible,
    onData: data => {
      const newAchievementIds: AchievementId[] =
        data.data.data?.user_by_pk?.undisplayed_achievements ?? []
      setAchievementIds(newAchievementIds)
    },
    onError: error => {
      logger.warning('Error fetching undisplayed achievements', { error })
    },
  })

  return { achievementIds, loading }
}
